var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container my-5" }, [
    _c("div", { staticClass: "row justify-content-center" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c(
            "form",
            { staticClass: "form-register" },
            [
              _c("h1", { staticClass: "text-center mb-4" }, [
                _vm._v(_vm._s(_vm.translate.login.phoneVerification.title))
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(_vm._s(_vm.translate.login.phoneVerification.subTitle))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("span", { staticClass: "error-input-container" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.code,
                        expression: "code"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "inputEmailOrPhone",
                      placeholder:
                        _vm.translate.login.phoneVerification.enterCodeHere,
                      type: "number"
                    },
                    domProps: { value: _vm.code },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.code = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("button-with-loading-component", {
                staticClass: "btn btn-primary btn-block ",
                attrs: {
                  type: "submit",
                  text: _vm.translate.login.phoneVerification.verify,
                  loading: _vm.loading
                },
                nativeOn: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.onSubmit($event)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("h2", { staticClass: "text-center mt-5" }, [
            _vm._v(_vm._s(_vm.translate.login.phoneVerification.reSendTitle))
          ]),
          _vm._v(" "),
          _vm.counter !== undefined
            ? _c("p", [
                _vm._v(
                  _vm._s(_vm.translate.login.phoneVerification.reSendSubtitle) +
                    " " +
                    _vm._s(_vm.counter)
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("button-with-loading-component", {
            staticClass: "btn btn-primary btn-block",
            attrs: {
              type: "submit",
              disabled: !_vm.canResend,
              text: _vm.translate.login.phoneVerification.reSend,
              loading: _vm.loadingResend
            },
            nativeOn: {
              click: function($event) {
                $event.preventDefault()
                return _vm.resendButton($event)
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8376fca", { render: render, staticRenderFns: staticRenderFns })
  }
}